import React, { useState } from "react";
import { useLang } from "@/lib/useLang";
import { getCandidateName } from "@/lib/i18n";

const COLOR_MAP = {
  saffron: { bg: "#FF9933", ink: "#0A0A0A" },
  green:   { bg: "#138808", ink: "#FFFFFF" },
  red:     { bg: "#E3000F", ink: "#FFFFFF" },
};

export const CandidateCard = ({ candidate, onVote, disabled, index }) => {
  const c = COLOR_MAP[candidate.color] || COLOR_MAP.saffron;
  const { t, lang } = useLang();
  const displayName = getCandidateName(candidate, lang);
  const [imgError, setImgError] = useState(false);
  const hasPhoto = !!candidate.photo && !imgError;

  return (
    <div
      className="brutal-card relative fade-up"
      style={{ animationDelay: `${index * 120}ms` }}
      data-testid={`candidate-card-${candidate.id}`}
    >
      <span className="tape" data-testid={`candidate-tape-${candidate.id}`}>
        {t("candidate_label")} 0{index + 1}
      </span>

      {/* Photo area with brand-color frame */}
      <div
        style={{ background: c.bg, height: "260px", position: "relative" }}
        className="flex items-center justify-center overflow-hidden"
      >
        {hasPhoto ? (
          <img
            src={candidate.photo}
            alt={displayName}
            crossOrigin="anonymous"
            onError={() => setImgError(true)}
            className="candidate-photo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "50% 18%",
              display: "block",
            }}
            data-testid={`candidate-photo-${candidate.id}`}
          />
        ) : (
          <span
            className="font-display"
            style={{ fontSize: "10rem", lineHeight: 1, letterSpacing: "-0.05em", color: c.ink }}
            data-testid={`candidate-initials-${candidate.id}`}
          >
            {candidate.initials}
          </span>
        )}
        {/* Bottom color stripe to preserve brand identity even with photo */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "10px",
            background: c.bg,
            borderTop: "3px solid #0A0A0A",
          }}
          aria-hidden="true"
        />
      </div>

      <div className="border-t-4 border-black p-6">
        <p className="text-xs uppercase font-bold tracking-[0.3em] text-neutral-600 mb-2">
          {t("party")}
        </p>
        <h3
          className="font-display uppercase leading-none mb-6"
          style={{ fontSize: "2.25rem" }}
          data-testid={`candidate-name-${candidate.id}`}
        >
          {displayName}
        </h3>

        <button
          className="brutal-btn w-full"
          onClick={() => onVote(candidate)}
          disabled={disabled}
          data-testid={`vote-btn-${candidate.id}`}
        >
          {disabled ? t("voting") : t("cast_vote")}
        </button>
      </div>
    </div>
  );
};

export default CandidateCard;
